import { connect } from 'react-redux';
import {
    pauseMediaPlayer,
    playMediaPlayer,
    playLive,
    onMediaEnded,
    onMediaLoading,
    /* onMediaLoaded, */
    onMediaPlaying,
    playMediaFromSourceWithMeta,
    onMediaError,
} from '../actions/MediaPlayerActions';
import { setCurrentTrack } from '../../../common/Playlist/actions/PlaylistActions';
import MediaPlayer from '../components/MediaPlayerComponent';

const isProduction = process.env.NODE_ENV === 'production';

const _logEvents = (message) => {
    if (!isProduction) {
        // eslint-disable-next-line no-console
        console.log(message);
    }
};

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const nowPlayingMusic = aovivoBar.MediaPlayer.isLive === 'otherMedia'
        ? aovivoBar.NowPlaying.music
        : aovivoBar.NowPlaying.musicLive;

    return {
        currentStreamId: aovivoBar.MediaPlayer.currentStreamId,
        currentStream: aovivoBar.MediaPlayer.currentStream,
        currentSources: aovivoBar.MediaPlayer.currentSources,
        isLive: aovivoBar.MediaPlayer.isLive,
        shouldBePlaying: aovivoBar.MediaPlayer.shouldBePlaying,
        volume: aovivoBar.Volume.volume,
        playerStatus: aovivoBar.MediaPlayer.playerStatus,
        trackList: state.playlist.trackList,
        currentIndex: state.playlist.currentIndex,
        nowPlayingMusic,
        locked: aovivoBar.AovivoBar.locked,
        jwt: state.profile.jwt,
        userId: state.profile.user.userId,
        isPro: state.profile.user.isPro,
        browserHash: state.profile.browserHash,
        prerollAdTagUrls: state.app.prerollAdTagUrls,
    };
};
const mapDispatchToProps = (dispatch) => ({
    playLive: () => {
        dispatch(playLive());
    },
    playMediaPlayer: () => {
        dispatch(playMediaPlayer());
    },
    pausePlayer: () => {
        dispatch(pauseMediaPlayer());
    },
    onError: () => {
        // This is never called as this is (should be) completely handled by the mediaPlayer
        _logEvents('onError...');

        dispatch(onMediaError()); // stop and finish the player upon error.
    },
    onPause: () => {
        _logEvents('onPause...');

        dispatch(pauseMediaPlayer());
    },
    onCanPlay: () => {
        _logEvents('onCanPlay...');
        // not used in playerStatus current version.
        // dispatch(onMediaLoaded())
    },
    onEnded: () => {
        _logEvents('onEnded...');

        dispatch(onMediaEnded());
    },
    onLoading: () => {
        _logEvents('onLoading...');

        dispatch(onMediaLoading());
    },
    onPlaying: () => {
        _logEvents('onPlaying...');

        dispatch(onMediaPlaying());
    },
    playMediaFromSourceWithMeta: (src, meta) => {
        dispatch(playMediaFromSourceWithMeta({ src, type: 'audio/mp3' }, meta));
    },
    setCurrentTrack: (currentIndex, currentMusicId) => {
        dispatch(setCurrentTrack(currentIndex, currentMusicId));
    },
    // other possible media element events:
    /*
        onLoaded: () => {
            _logEvents('onLoaded...');
            dispatch(onMediaLoaded());
        },
        onPlay: () => {
            _logEvents('onPlay...');
            dispatch(onMediaPlaying())
        },
        onLoadedData: () => {
            _logEvents('onLoadedData...');
            dispatch(onMediaLoaded())
        },
        */
});
const MediaPlayerContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MediaPlayer);

export default MediaPlayerContainer;
